document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("ces-2026-map")) {
    class CES2026Map extends HTMLElement {
      constructor() {
        super();
        this.swiperContainer = $(this).find(".swiper-container");
        this.titles = $(this).find(".ces-2026-map-card-warper");
      }

      connectedCallback() {
        this.initSwiper();
        this.initMapCard();
      }

      initSwiper() {
        const self = this;
        if (this.swiperContainer.length !== 0) {
          this.swiperInstance = new Swiper(this.swiperContainer[0], {
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            on: {
              slideChange() {
                const index = $(self.titles[this.activeIndex]).data("map");
                self.setActiveMapCard(index);
              },
            },
          });
        }
      }

      initMapCard() {
        this.setActiveMapCard($(this.titles[0]).data("map"));
        this.titles.each((index, el) => {
          $(el).on("click", () => {
            if (this.swiperInstance) {
              this.swiperInstance.slideTo(String(index));
            }
          });
        });
      }

      setActiveMapCard(index) {
        this.titles.each((_, el) => {
          const $el = $(el);
          if ($el.data("map") === index) {
            $el.addClass("active");
            
            const $container = $el.parent();
            const elLeft = el.offsetLeft;
            const elWidth = el.offsetWidth;
            const containerWidth = $container[0].clientWidth;

            const targetScrollLeft = elLeft - (containerWidth - elWidth) / 2;

            $container.stop().animate({ scrollLeft: targetScrollLeft }, 300);
          } else {
            $el.removeClass("active");
          }
        });
      }
    }
    customElements.define("ces-2026-map", CES2026Map);
  }
});
